import {send} from "@/composables/apiClient";

// Short-lived MQTT JWT handling. The API signs a per-company ES256 token that
// the broker validates offline; the client presents it as the MQTT password and
// is scoped to its own company's topics. Tokens are short lived, so callers
// refresh before expiry and reconnect.

let cachedToken = null;
let expiresAtMs = 0;
let cachedWsUrl = null;

// Fetch a fresh MQTT token for the current company. Throws if unavailable so
// callers can fall back or surface the failure rather than connecting blind.
export async function fetchMqttToken() {
    // Bound the request: it is awaited inside the reconnect path, so a hung token
    // fetch (no default axios timeout) would stall a reconnect indefinitely.
    const response = await send("get", "mqtt/token", null, {timeout: 8000});
    const data = response && response.data && response.data.data;
    if (!response || response.data?.success === false || !data?.token) {
        throw new Error("MQTT token unavailable");
    }
    const expiresIn = Number(data.expires_in) > 0 ? Number(data.expires_in) : 1800;
    cachedToken = data.token;
    cachedWsUrl = data.ws_url || process.env.VUE_APP_MQTT_URL || null;
    expiresAtMs = Date.now() + expiresIn * 1000;
    return {token: cachedToken, wsUrl: cachedWsUrl, expiresIn};
}

// Milliseconds until the token should be refreshed (60s safety margin), or 0 if
// there is no token yet.
export function msUntilRefresh() {
    if (!cachedToken) return 0;
    return Math.max(0, expiresAtMs - Date.now() - 60000);
}

export function companyTopicPrefix(companyId) {
    return companyId ? `c/${companyId}/` : "";
}
